/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { PageTemplate } from '../../templates/pageTemplate';
import { ContentTemplate } from '../../templates/contentTemplate';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
import GenericErrorImage from './assets/image-error-generic.svg';
import { useIntl } from 'react-intl';
export var GenericError = function GenericError(_ref) {
  var onBack = _ref.onBack,
    error = _ref.error,
    message = _ref.message;
  var intl = useIntl();
  useDocumentTitle(intl.formatMessage({
    id: 'embers.pageTitle.error.genericError',
    defaultMessage: '{errorMessage} - Promethean'
  }, {
    errorMessage: error
  }));
  return /*#__PURE__*/React.createElement(PageTemplate, null, /*#__PURE__*/React.createElement(ContentTemplate, {
    type: "error",
    pageTitle: error,
    errorMessage: message,
    errorImage: GenericErrorImage,
    onBack: onBack
  }));
};